import { serviceAPI } from "./service";
import {
  FETCH_ORGANIZATION_SECURE_URL,
  FETCH_ORGANIZATION_URL,
  SAVE_ORGANIZATION_URL,
  GET_POSSIBLE_ORGANIZATIONS_FOR_COLLAPSE_URL,
  GET_DUPLICATED_ORGANIZATIONS_BY_NAME_URL,
  GET_RELATIONSHIPS_BY_ORGANIZATION_ID_URL,
  UPDATE_COLLAPSE_ORGANIZATION_URL,
  TOGGLE_SYSTEM_VENDOR_URL,
  MERGE_ORGANIZATIONS_URL,
  GET_SYSTEM_ORGANIZATIONS_URL,
} from "../constants/url.constants";
import { handleErrorResponse } from "../actions/message";

export const saveOrganization = (data) => {
  return serviceAPI
    .post(SAVE_ORGANIZATION_URL, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};

//GET REQUEST
export const fetchOrganization = (organizationId) => {
  return serviceAPI
    .get(FETCH_ORGANIZATION_URL + organizationId)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};

//GET REQUEST
export const fetchOrganizationSecure = (organizationId) => {
  return serviceAPI
    .get(FETCH_ORGANIZATION_SECURE_URL + organizationId)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};

export const getPossibleOrganizationsForCollapse = () => {
  return serviceAPI
    .get(GET_POSSIBLE_ORGANIZATIONS_FOR_COLLAPSE_URL)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};

export const getDuplicatedOrganizationsByName = (orgId) => {
  return serviceAPI
    .get(GET_DUPLICATED_ORGANIZATIONS_BY_NAME_URL + orgId)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};

export const getRelationshipsToOrganization = (orgId) => {
  return serviceAPI
    .get(GET_RELATIONSHIPS_BY_ORGANIZATION_ID_URL + orgId)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};

export const updateCollapseOrganization = (data) => {
  return serviceAPI
    .post(UPDATE_COLLAPSE_ORGANIZATION_URL, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};

export const togglesystemOrganization = (orgId) => {
  return serviceAPI
    .post(TOGGLE_SYSTEM_VENDOR_URL + orgId)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};

export const mergeOrganizations = (maintainedOrgId, collapsedOrgId) => {
  return serviceAPI
    .post(
      MERGE_ORGANIZATIONS_URL +
        maintainedOrgId +
        "&collapsedOrgId=" +
        collapsedOrgId,
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};

export const getSystemOrganizations = () => {
  return serviceAPI
    .get(GET_SYSTEM_ORGANIZATIONS_URL)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      handleErrorResponse(error);
    });
};
